var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBgShape(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 428,
    height: 220,
    viewBox: "0 0 428 220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_319_738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151 127.7C156.6 122.6 162.3 117.7 166.6 112.3C175.4 101.1 181.7 88 184.9 74.1C187.3 63.8 187.2 53.2 187.4 42.7C187.5 33.9 186 22.6 194.3 16.9C210.2 5.89996 218.2 29.1 221.2 40.7C232.8 86.9 227.2 148.2 177.4 169.6C167.4 173.9 154.5 177.5 143.8 174.1C135.2 171.4 131.4 163.7 132.6 155.2C134.2 143.9 142.4 135.6 151 127.7Z",
    stroke: "url(#paint0_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.8 135C142.1 134 142.2 132.4 143.1 131.5C144 130.6 145.6 130.6 146.6 131.3",
    stroke: "url(#paint1_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.9 151.8C143 153.2 144.3 154.4 145.8 154.5C147.2 154.6 148.6 153.5 148.9 152.1C149.2 150.7 148.3 149.2 146.9 148.7",
    stroke: "url(#paint2_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.9 129.2C169.3 130.4 171.4 130.6 173 129.7C174.6 128.8 175.5 126.8 175.2 125C174.9 123.2 173.4 121.7 171.6 121.3",
    stroke: "url(#paint3_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.2 107.3C169 106.8 168.5 105.2 169.1 104.1C169.7 103 171.3 102.6 172.4 103.4",
    stroke: "url(#paint4_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.6 146.6C177.1 144.5 179.6 143.1 181.7 143.9C183.7 144.7 184.6 147.5 183.5 149.3",
    stroke: "url(#paint5_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.3 165C165.7 164 166.2 162.4 167.4 162C168.5 161.6 170 162.4 170.2 163.6",
    stroke: "url(#paint6_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.8 174.6C147.1 173.4 148.3 172.4 149.6 172.5C150.9 172.6 152 173.7 152.1 175",
    stroke: "url(#paint7_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.4 165.9C185.9 167.2 187.5 168.1 188.9 167.9C190.3 167.7 191.6 166.7 192.2 165.4C192.8 164.1 192.9 162.6 192.6 161.2",
    stroke: "url(#paint8_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202 139.8C201.9 138.9 202.6 138 203.4 137.9C204.3 137.8 205.2 138.5 205.3 139.3",
    stroke: "url(#paint9_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.3 115.9C192.9 114.9 194.2 114.3 195.4 114.6C196.6 114.9 197.4 116.1 197.4 117.3",
    stroke: "url(#paint10_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.4 104.7C182.2 104.3 181.6 102.8 182.2 101.7C182.8 100.6 184.4 100.3 185.4 101.1",
    stroke: "url(#paint11_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209 95.6999C209.5 94.9999 210.5 94.6999 211.3 95.0999C212.1 95.4999 212.5 96.4999 212.2 97.2999",
    stroke: "url(#paint12_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.7 108C215.1 108.2 216.2 109.6 216.1 111C216 112.4 214.8 113.7 213.3 113.7",
    stroke: "url(#paint13_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.9 91.9999C193.1 91.4999 193.2 89.9999 194.1 89.5999C195 89.1999 196.1 90.0999 196 91.0999",
    stroke: "url(#paint14_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.2 78.6C217.2 77.7 218.1 76.8 219 76.9C219.9 76.9 220.8 77.8 220.7 78.7C220.7 79.6 219.8 80.4 218.8 80.4",
    stroke: "url(#paint15_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.4 77C192.3 76.4 192.2 74.7 193.1 73.9C194 73.1 195.7 73.5 196.2 74.6",
    stroke: "url(#paint16_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.5 55.2C201.3 55.6 200.9 57.3999 201.8 58.2999C202.6 59.1999 204.4 59 204.9 57.9",
    stroke: "url(#paint17_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.4 45.0999C211.2 44.5999 212.5 44.9999 212.9 45.8999C213.3 46.7999 212.7 47.9999 211.7 48.1999",
    stroke: "url(#paint18_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.9 38.6C193.8 39.1 193.4 40.9 194.3 41.7C195.2 42.6 197 42.1 197.4 41",
    stroke: "url(#paint19_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.3 21.6999C198.3 20.8999 199.3 20.3999 200 20.6999C200.7 20.9999 200.9 22.0999 200.3 22.5999",
    stroke: "url(#paint20_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.1 30.1C185.9 30.4 184.9 31.6 184.9 32.9C184.9 34.2 186 35.3 187.3 35.5",
    stroke: "url(#paint21_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.4 34.8C220.5 34.7 221.7 35.3 222.2 36.4C222.7 37.4 222.5 38.7 221.7 39.5",
    stroke: "url(#paint22_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185 71C183.9 71.1 182.9 72.1 182.7 73.2C182.5 74.3 183.1 75.5 184 76.1",
    stroke: "url(#paint23_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226 94C227.1 93.1 228.2 92.2 228.6 90.8C228.9 89.5 228 87.7 226.6 87.8",
    stroke: "url(#paint24_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.3 126.9C219.2 127.6 220.5 127.4 221.3 126.6C222.1 125.9 222.4 124.7 222.2 123.6C222 122.5 221.4 121.5 220.7 120.7",
    stroke: "url(#paint25_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.4 148C208.1 148.3 209.9 147.5 210.9 146C211.8 144.6 211.9 142.6 211 141.1",
    stroke: "url(#paint26_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350 144.2C345.4 143.3 340.9 142.3 336.6 142.2C327.8 142 319 143.7 310.9 147.2C304.9 149.8 299.7 153.8 294.4 157.6C290 160.8 285 165.7 279.1 163.7C267.8 159.9 276.3 147.4 281 141.6C299.6 118.8 332.1 99 361.1 115.7C366.9 119.1 373.4 124.1 375.7 130.7C377.5 135.9 375.1 140.7 370.4 143.2C364.2 146.6 357.1 145.6 350 144.2Z",
    stroke: "url(#paint27_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.6 145.6C356.4 146.3 355.5 146.9 354.8 146.7C354 146.6 353.4 145.8 353.4 145",
    stroke: "url(#paint28_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365 139.4C365.6 138.8 365.8 137.7 365.3 137C364.8 136.3 363.8 136 363 136.4C362.2 136.8 361.8 137.8 362 138.6",
    stroke: "url(#paint29_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.5 135.3C344.6 134.2 343.9 133 342.8 132.6C341.8 132.1 340.5 132.4 339.7 133.2C338.9 134 338.7 135.3 339.2 136.4",
    stroke: "url(#paint30_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.8 142.3C333 143.1 332.4 143.9 331.6 144C330.8 144.1 330 143.4 330 142.7",
    stroke: "url(#paint31_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350 124.6C348.8 125.2 347.1 124.4 346.8 123.1C346.5 121.8 347.5 120.3 348.8 120.2",
    stroke: "url(#paint32_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.9 122.9C362.6 123.6 361.6 123.9 361 123.5C360.4 123.1 360.3 122.1 360.8 121.5",
    stroke: "url(#paint33_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.8 129C374.1 129.3 373.2 129 372.7 128.4C372.3 127.7 372.4 126.8 373 126.3",
    stroke: "url(#paint34_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.2 113.1C356.7 112.4 356.5 111.3 355.9 110.6C355.3 110 354.3 109.7 353.4 109.9C352.5 110.1 351.8 110.6 351.2 111.3",
    stroke: "url(#paint35_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.2 114.5C336.8 114.9 336.1 114.9 335.7 114.5C335.3 114.1 335.3 113.4 335.7 113",
    stroke: "url(#paint36_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.9 128.1C328.2 128.2 327.4 127.7 327.1 127C326.8 126.3 327.1 125.4 327.7 125",
    stroke: "url(#paint37_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.6 136.7C326.9 137.4 326.3 138.3 325.6 138.4C324.8 138.5 324.1 137.8 324.1 137",
    stroke: "url(#paint38_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.8 127.3C312.3 127.3 311.7 126.9 311.6 126.4C311.5 125.9 311.8 125.3 312.4 125.1",
    stroke: "url(#paint39_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.1 120.5C316.7 119.7 317 118.7 317.7 118.2C318.4 117.7 319.5 117.9 320.1 118.6",
    stroke: "url(#paint40_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.5 136.2C316.5 136.8 315.8 137.3 315.3 137C314.8 136.7 314.8 135.8 315.3 135.5",
    stroke: "url(#paint41_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.2 129.5C300.7 129.8 300 129.7 299.7 129.2C299.4 128.7 299.5 128 300 127.7C300.5 127.4 301.2 127.5 301.5 128",
    stroke: "url(#paint42_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.3 141.9C309.4 142.7 308.6 143.4 307.8 143.2C307.1 143 306.6 142.1 307 141.4",
    stroke: "url(#paint43_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.1 145.5C295.7 145.9 296.7 145.5 296.9 144.7C297 144 296.3 143.2 295.5 143.3",
    stroke: "url(#paint44_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.2 145.3C286.6 145.1 286.4 144.3 286.7 143.8C287 143.3 287.8 143.1 288.3 143.5",
    stroke: "url(#paint45_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.6 155.4C290.3 155.8 291.3 155.3 291.3 154.5C291.4 153.7 290.5 153 289.8 153.2",
    stroke: "url(#paint46_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280 160C279.6 160.3 279 160 278.9 159.5C278.8 159 279.3 158.5 279.7 158.6",
    stroke: "url(#paint47_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.3 162.4C288.9 162.9 289.9 162.9 290.5 162.4C291.1 161.9 291.3 161 290.9 160.3",
    stroke: "url(#paint48_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.7 144.7C278.2 144.2 278.1 143.4 278.5 142.8C278.8 142.2 279.5 141.8 280.2 141.9",
    stroke: "url(#paint49_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.3 148.3C309.8 148.8 310.6 149 311.2 148.6C311.8 148.3 312.2 147.6 312.1 146.9",
    stroke: "url(#paint50_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.6 119.5C304.8 119.3 303.9 119.1 303.1 119.4C302.3 119.7 301.8 120.8 302.4 121.5",
    stroke: "url(#paint51_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.8 111.2C324.8 110.5 324.2 109.9 323.6 109.8C322.9 109.7 322.2 110 321.8 110.5C321.3 111 321.1 111.6 320.9 112.3",
    stroke: "url(#paint52_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.6 109.3C339.1 108.4 338 107.8 337 107.8C335.9 107.9 334.9 108.6 334.6 109.6",
    stroke: "url(#paint53_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.9 240.2C97 244.7 97.9 249.3 99.5 253.3C102.9 261.4 108.1 268.8 114.5 274.7C119.3 279.1 125.1 282.3 130.7 285.5C135.4 288.2 142 290.8 142.5 297C143.6 308.9 128.7 306.2 121.5 304.3C93.1 296.6 61.7 275.1 65.2 241.8C65.9 235.1 67.9 227.1 72.9 222.3C76.9 218.5 82.2 218.8 86.5 222C92.2 226.3 94.2 233.2 95.9 240.2Z",
    stroke: "url(#paint54_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.5 197.1C103.1 195.4 112.2 194.2 115.2 191.8C118.2 189.5 120.7 186.2 121.3 182.5C121.7 180.4 121.4 178.1 120 176.5C118.7 175 116.6 174.4 114.6 174.5C112.6 174.6 110.7 175 108.9 175.6C113.4 173.6 117.9 171.6 121.6 168.5C123.6 166.7 125.4 164.5 126 161.9C126.6 159.3 125.7 156.2 123.4 154.7C121.1 153.3 116.3 153.7 115.5 156.2C116.5 151.8 117.6 147.3 116.5 142.9C115.6 139.2 112.7 136 108.9 135.3C103.6 134.2 98.5999 136.4 96.3999 141.5C94.6999 145.6 95.1 150.3 95.5 154.8C95.1 152.1 90.3999 151.1 87.8999 152.2C85.3999 153.3 84.0999 156.2 84.3999 158.9C84.5999 161.6 86.0999 164 87.8999 166.1C91.0999 169.8 95.3 172.4 99.5 174.9C97.7 174 95.9 173.3 94 173C92 172.7 89.8999 173 88.3999 174.2C86.7999 175.6 86.1999 177.9 86.1999 180C86.2999 183.8 88.3 187.4 91 190.1C93.7 192.8 102.2 195.3 102.5 197.1Z",
    stroke: "url(#paint55_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.9 153.4C103.3 170.1 102.4 187 102.5 203.8",
    stroke: "url(#paint56_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.9 191C107.3 189.4 111.4 186.7 114.5 183.2",
    stroke: "url(#paint57_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.3 188.9C97.5 188.7 93 186 90.5 182",
    stroke: "url(#paint58_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.4 181.7C104.8 181.1 106.1 180.3 107.2 179.3",
    stroke: "url(#paint59_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.9 172.4C108.4 170.4 112.1 166.7 114.1 162.1",
    stroke: "url(#paint60_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.6 167.7C98.4 166.1 93.9 162.2 91.6 157.3",
    stroke: "url(#paint61_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.6 159.9C108 157 110.6 153.1 112 148.9",
    stroke: "url(#paint62_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.6 155.5C101.3 153.7 99.1 149.9 99.4 146.1",
    stroke: "url(#paint63_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.4 217.7C247.9 219.5 241 225.6 239.8 229.2C238.6 232.8 238.4 236.9 240 240.4C240.9 242.3 242.4 244.1 244.5 244.7C246.4 245.2 248.5 244.5 250.1 243.3C251.7 242.1 253 240.7 254.2 239.1C251.6 243.2 249 247.4 247.7 252.1C247 254.7 246.8 257.6 247.7 260.1C248.7 262.6 251.1 264.7 253.8 264.6C256.5 264.5 260.3 261.5 259.5 258.9C261.1 263.1 262.8 267.4 266.2 270.4C269.1 272.9 273.2 273.9 276.8 272.5C281.8 270.4 284.8 265.8 283.6 260.3C282.7 255.9 279.7 252.3 276.9 248.8C278.7 250.8 283.2 249 284.7 246.7C286.1 244.4 285.5 241.2 283.8 239.1C282.1 237 279.5 235.8 276.9 235.1C272.2 233.9 267.2 234.1 262.4 234.3C264.4 234 266.3 233.6 268.1 232.8C269.9 232 271.5 230.5 272.1 228.6C272.7 226.5 271.9 224.3 270.6 222.6C268.4 219.5 264.7 217.7 261 216.9C257.1 216.2 248.7 219 247.4 217.7Z",
    stroke: "url(#paint64_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.9 255.2C261.9 240.4 253.1 226.1 243.6 212.1",
    stroke: "url(#paint65_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.8 56.4C272.3 58.2 265.4 64.3 264.2 67.9C263 71.5 262.8 75.6 264.4 79.1C265.3 81 266.8 82.8 268.9 83.4C270.8 83.9 272.9 83.2 274.5 82C276.1 80.8 277.4 79.4 278.6 77.8C276 81.9 273.4 86.1 272.1 90.8C271.4 93.4 271.2 96.3 272.1 98.8C273.1 101.3 275.5 103.4 278.2 103.3C280.9 103.2 284.7 100.2 283.9 97.6C285.5 101.8 287.2 106.1 290.6 109.1C293.5 111.6 297.6 112.6 301.2 111.2C306.2 109.1 309.2 104.5 308 99C307.1 94.6 304.1 91 301.3 87.5C303.1 89.5 307.6 87.7 309.1 85.4C310.5 83.1 309.9 79.9 308.2 77.8C306.5 75.7 303.9 74.5 301.3 73.8C296.6 72.6 291.6 72.8 286.8 73C288.8 72.7 290.7 72.3 292.5 71.5C294.3 70.7 295.9 69.2 296.5 67.3C297.1 65.2 296.3 63 295 61.3C292.8 58.2 289.1 56.4 285.4 55.6C281.5 54.9 273.1 57.7 271.8 56.4Z",
    stroke: "url(#paint66_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.3 93.9001C286.3 79.1001 277.5 64.8 268 50.8",
    stroke: "url(#paint67_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.9 61.7001C272.1 65.5001 270.3 70.0001 269.7 74.7001",
    stroke: "url(#paint68_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.5 63.1001C280.5 60.6001 285.8 60.2001 290.2 62.2001",
    stroke: "url(#paint69_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.7 69.6001C278.9 70.8001 278.3 72.2001 278 73.7001",
    stroke: "url(#paint70_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.5 77.6001C281.9 81.8001 280.9 87.0001 281.8 91.8001",
    stroke: "url(#paint71_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.4 81.4C292.6 79.8 298.5 80.5 303.2 83.3",
    stroke: "url(#paint72_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.9 88.4C289.7 92.7 289.7 97.4 291 101.7",
    stroke: "url(#paint73_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.4 92.0001C297.2 91.6001 301.1 93.6001 303 96.8001",
    stroke: "url(#paint74_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.9 95.8C385.5 94.6 387.8 85.7 386.7 82C385.6 78.3 383.5 74.8 380.3 72.8C378.5 71.7 376.2 71.1 374.2 71.8C372.3 72.5 371 74.2 370.3 76.1C369.6 78 369.3 79.9 369.2 81.9C369 77 368.8 72.1 367.2 67.5C366.3 64.9 364.9 62.5 362.7 60.9C360.5 59.4 357.3 59 355.1 60.6C352.9 62.2 351.5 66.8 353.6 68.5C349.9 65.9 346.1 63.3 341.6 62.7C337.8 62.2 333.8 63.7 331.7 66.9C328.7 71.4 328.9 76.9 332.9 80.8C336.1 83.9 340.6 85.3 344.9 86.5C342.3 85.9 339.5 89.9 339.6 92.6C339.7 95.3 342 97.6 344.6 98.4C347.2 99.2 350 98.7 352.6 97.8C357.2 96.2 361.2 93.2 365.1 90.3C363.6 91.6 362.3 93 361.3 94.7C360.3 96.4 359.7 98.5 360.4 100.4C361.1 102.4 363 103.8 365 104.5C368.6 105.8 372.6 105.2 376.1 103.8C379.7 102.5 385.1 95.4 386.9 95.8Z",
    stroke: "url(#paint75_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.2 77.4C362.2 85.1 377.5 92.1 393.1 98.3",
    stroke: "url(#paint76_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.3 93.2C381.5 88.5 380.4 83.7 378.3 79.5",
    stroke: "url(#paint77_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.2 92.9C377.3 97.3 373.1 100.5 368.4 101.3",
    stroke: "url(#paint78_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373 89.3C373 87.8 372.7 86.3 372.1 84.9",
    stroke: "url(#paint79_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.5 85.4001C364.3 80.5001 362.2 75.6001 358.7 72.1001",
    stroke: "url(#paint80_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360 83.9C356.6 88.2 351.3 90.9 345.9 91.2",
    stroke: "url(#paint81_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.1 80.1001C351.7 75.9001 349 72.0001 345.6 69.2001",
    stroke: "url(#paint82_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349 78.5C346.1 80.9 341.8 81.5 338.3 79.9",
    stroke: "url(#paint83_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.30003 117.1C10.6 119.5 2.50002 130.7 2.00002 136.4C1.50002 142.1 2.50003 148.1 5.90003 152.7C7.80003 155.3 10.7 157.4 13.9 157.5C16.9 157.6 19.7 155.9 21.7 153.7C23.7 151.5 25.1 149 26.4 146.3C24 153.2 21.5 160.2 21.2 167.5C21 171.6 21.6 175.8 23.9 179.2C26.2 182.6 30.4 184.8 34.4 183.8C38.3 182.8 42.8 177.1 40.8 173.6C44.5 179.2 48.4 185 54.3 188.3C59.3 191.1 65.7 191.2 70.5 187.9C77.2 183.2 80 175.5 76.5 167.9C73.7 161.8 68.2 157.4 62.9 153.3C66.3 155.6 72.3 151.5 73.6 147.7C74.9 143.9 73 139.4 69.9 136.9C66.7 134.4 62.5 133.5 58.5 133.3C51.2 133 44 135 37 136.9C39.8 135.9 42.4 134.6 44.8 132.8C47.2 131 49.1 128.3 49.2 125.4C49.4 122.2 47.5 119.2 45.1 117.1C40.8 113.3 34.9 111.9 29.2 112C23.1 111.7 11.6 118.6 9.30003 117.1Z",
    stroke: "url(#paint84_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6 164.6C38 145.6 20.4 127.4 2.09998 110.2",
    stroke: "url(#paint85_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6 123.8C12.8 130.3 11.6 137.5 12.2 144.5",
    stroke: "url(#paint86_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4 125.3C23.5 120.3 31.1 118 38.1 119.5",
    stroke: "url(#paint87_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1 133.8C24.3 135.9 23.9 138.1 23.9 140.4",
    stroke: "url(#paint88_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8 143.9C32.4 150.9 32.6 158.8 35.5 165.6",
    stroke: "url(#paint89_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3 148.5C47.4 144.4 56.3001 143.6 64.1001 146.1",
    stroke: "url(#paint90_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7001 157.6C47.3001 164.3 48.9001 171.1 52.2001 177",
    stroke: "url(#paint91_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.6 162.1C58 160.3 64.4 161.9 68.2 166.1",
    stroke: "url(#paint92_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.2 180.9C220.8 182.3 209.3 174.7 203.6 174.4C197.9 174.1 191.9 175.4 187.5 179C185 181 183 184 183.1 187.2C183.1 190.2 185 192.9 187.3 194.8C189.6 196.7 192.2 198 194.9 199.1C187.9 197 180.8 194.8 173.5 194.8C169.4 194.8 165.2 195.6 162 198C158.7 200.4 156.7 204.8 157.9 208.6C159.1 212.5 165 216.7 168.4 214.6C163 218.5 157.3 222.7 154.3 228.7C151.7 233.8 151.9 240.2 155.5 244.8C160.5 251.3 168.3 253.7 175.8 249.9C181.8 246.9 185.9 241.2 189.8 235.7C187.7 239.1 192 245 195.9 246.1C199.8 247.3 204.1 245.2 206.5 241.9C208.9 238.6 209.6 234.4 209.6 230.3C209.5 223 207.3 215.9 205.1 209C206.3 211.7 207.6 214.3 209.5 216.6C211.4 218.9 214.1 220.7 217.1 220.7C220.3 220.7 223.2 218.7 225.2 216.2C228.8 211.7 230 205.8 229.6 200C229.2 194.5 221.8 183.3 223.2 180.9Z",
    stroke: "url(#paint93_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.7 228.2C196 210.8 213.3 192.5 229.8 173.3",
    stroke: "url(#paint94_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.8 187.6C210.2 185 203 184.2 195.9 185.1",
    stroke: "url(#paint95_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.4 190.4C220.6 195.2 223.2 202.8 222.1 209.8",
    stroke: "url(#paint96_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.2 197.5C205.1 196.8 202.8 196.5 200.6 196.6",
    stroke: "url(#paint97_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.5 207.6C190.4 205.5 182.5 206.1 175.8 209.3",
    stroke: "url(#paint98_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.2 213.3C197.6 220.2 198.8 229 196.6 236.9",
    stroke: "url(#paint99_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.4 221.1C177.7 221 170.9 222.9 165.2 226.4",
    stroke: "url(#paint100_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134 10.8C161.9 29.6 162.4 76.5 142.7 102.4C117.1 136 59.3 121.9 42.6 83.2C19.8 30.7 86.5 -21.1 134 10.8Z",
    stroke: "url(#paint101_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.9 59.3001C46.5 42.2001 55.8 25.8001 70.1 16.4001C84.4 7.00006 105.2 4.10005 120.8 11.4001C136.3 18.7001 149 33.9001 148.9 51.1001",
    stroke: "url(#paint102_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65 89.9C66 90.8 67 91.6 68 92.2C72.1 94.9 75.9 93.6 79.2 90.4C82.6 87.1 85.6 83.4 88.2 79.4C89.8 76.9 91.3 73.9 90.2 71.1C87.8 64.4 77.2 63.9 71.4 63.7C66.1 63.5 57.2 63 55.4 69.4C53.4 76 59.3 84.9 65 89.9Z",
    stroke: "url(#paint103_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4 72.4C65.6 72.6 64.7 72.7 63.9 72.5C63.1 72.3 62.3 71.6 62.2 70.8C62.1 70.1 62.6 69.4 63.1 69C63.7 68.6 64.4 68.4 65 68.2C66.7 67.8 78.3 65 78.9 67.3C79.7 69.9 68 72.2 66.4 72.4Z",
    fill: "url(#paint104_linear_319_738)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6 82.8C73 83.4 72.4 84 72.1 84.8C71.8 85.6 71.9 86.6 72.5 87.2C73 87.7 73.8 87.7 74.5 87.5C75.2 87.3 75.7 86.8 76.3 86.4C77.6 85.3 86.6 77.4 85.1 75.6C83.4 73.5 74.8 81.7 73.6 82.8Z",
    fill: "url(#paint105_linear_319_738)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.3 81.7C67.6 82.1 66.8 82.6 65.9 82.6C65.1 82.7 64.1 82.3 63.7 81.5C63.4 80.9 63.6 80.1 64 79.5C64.4 78.9 65 78.5 65.6 78.1C67.1 77.1 77 70.6 78.4 72.5C80 74.8 69.7 80.9 68.3 81.7Z",
    fill: "url(#paint106_linear_319_738)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7 44.8C65.5 46.1 65.5 47.4 65.5 48.5C65.6 53.4 68.9 55.8 73.4 56.7C78.1 57.6 82.8 58 87.6 57.8C90.6 57.7 93.9 57.2 95.6 54.7C99.7 48.9 94.1 39.9 91 35C88.2 30.5 83.6 22.9 77.2 25.1C70.6 27.4 66.6 37.3 65.7 44.8Z",
    stroke: "url(#paint107_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8999 36.1C80.2999 35.5 79.6999 34.9 79.3999 34.1C79.0999 33.3 79.1999 32.3 79.8999 31.7C80.3999 31.3 81.1999 31.2 81.8999 31.4C82.5999 31.6 83.0999 32.1 83.6999 32.6C84.9999 33.8 93.8999 41.7 92.3999 43.5C90.4999 45.6 81.9999 37.2 80.8999 36.1Z",
    fill: "url(#paint108_linear_319_738)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78 49.2C77.5 49.1 76.9 49 76.4 49.1C75.9 49.2 75.4 49.6 75.4 50.1C75.4 50.5 75.6 51 76 51.2C76.3 51.5 76.8 51.6 77.2 51.7C78.2 52 85.4 53.8 85.8 52.4C86.2 50.9 79 49.4 78 49.2Z",
    fill: "url(#paint109_linear_319_738)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3 42.9001C73.5 42.5001 72.7 42.1001 72.2 41.5001C71.7 40.8001 71.4 39.9001 71.8 39.1001C72.2 38.5001 72.9 38.2001 73.6 38.2001C74.3 38.2001 75 38.4001 75.6 38.7001C77.2 39.4001 88.3 43.9001 87.4 46.1001C86.6 48.6001 75.8 43.6001 74.3 42.9001Z",
    fill: "url(#paint110_linear_319_738)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.3 28.2C121.1 27.6 119.9 27.2 118.8 26.9C114.1 25.5 110.8 27.9 108.6 31.9C106.3 36.1 104.5 40.5 103.3 45.1C102.5 48 102 51.3 103.8 53.7C108 59.4 118.4 56.7 124 55.3C129.1 54 137.8 51.9 137.6 45.2C137.4 38.1 129.2 31.3 122.3 28.2Z",
    stroke: "url(#paint111_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.9 46.9C125.4 46.7 125.9 46.4 126.4 46.4C126.9 46.4 127.5 46.6 127.7 47.1C127.9 47.5 127.7 48 127.5 48.3C127.2 48.6 126.9 48.9 126.5 49.1C125.6 49.7 119.2 53.4 118.4 52.2C117.5 50.8 124 47.4 124.9 46.9Z",
    fill: "url(#paint112_linear_319_738)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.1 37.5C116.5 36.8 116.9 36 117 35.1C117.1 34.2 116.7 33.3 115.9 33C115.3 32.7 114.5 32.9 113.9 33.3C113.3 33.7 112.9 34.3 112.5 34.9C111.6 36.4 105.3 46.5 107.3 47.8C109.5 49.3 115.3 38.9 116.1 37.5Z",
    fill: "url(#paint113_linear_319_738)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.5 37C122.1 36.4 122.7 35.7 123.5 35.4C124.3 35.1 125.3 35.1 125.9 35.8C126.4 36.3 126.4 37.1 126.2 37.8C126 38.5 125.6 39.1 125.1 39.6C124 41 116.4 50.1 114.5 48.7C112.4 47 120.4 38.1 121.5 37Z",
    fill: "url(#paint114_linear_319_738)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9 72.3C99.1 70.3 99.3 68.1 100.9 66.9C102 66 103.4 65.7999 104.8 65.5999C113 64.4999 121.2 63.4 129.4 62.3C130.1 62.2 130.9 62.1 131.5 62.4C132.5 62.9 132.8 64.0999 133 65.1999C133.7 70.9999 132.3 76.8999 129.9 82.1999C126.9 88.7999 122.2 94.7 116 98.5C112.3 100.8 108.1 102.2 103.8 102.5C100.5 102.8 97.1001 102.6 94.0001 101.4C90.6001 100 89.7 97.5 91.4 94.3C93.2 90.9 95.1001 87.5 96.5001 83.9C97.8001 80.2 98.5 76.2 98.9 72.3Z",
    stroke: "url(#paint115_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.5 69.8999C123 69.8999 123.6 69.9999 124 70.1999C124.5 70.3999 124.8 70.9999 124.8 71.4999C124.7 71.8999 124.4 72.2999 124 72.3999C123.6 72.4999 123.2 72.5999 122.7 72.5999C121.6 72.5999 114.3 72.5999 114.2 71.0999C114.2 69.4999 121.5 69.7999 122.5 69.8999Z",
    fill: "url(#paint116_linear_319_738)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121 78.6C121.8 79 122.6 79.3 123.1 80C123.6 80.7 123.9 81.6 123.5 82.4C123.1 83 122.4 83.3 121.7 83.3C121 83.3 120.3 83.1 119.7 82.8C118.1 82.2 107 77.7 107.8 75.5C108.7 73 119.6 78 121 78.6Z",
    fill: "url(#paint117_linear_319_738)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.4 88.2C116.1 88.7 116.7 89.3 117.1 90.1C117.5 90.9 117.4 91.9 116.8 92.5C116.3 93 115.5 93.1 114.8 92.9C114.1 92.7 113.5 92.3 113 91.9C111.6 90.8 102.1 83.6 103.5 81.7C105 79.5 114.2 87.1 115.4 88.2Z",
    fill: "url(#paint118_linear_319_738)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.9 93.0999C106.1 93.5999 106.4 94.0999 106.4 94.5999C106.4 95.0999 106.2 95.6999 105.7 95.8999C105.3 96.0999 104.8 95.8999 104.5 95.6999C104.2 95.4999 103.9 95.0999 103.7 94.6999C103.2 93.7999 99.5001 87.3999 100.7 86.5999C102 85.5999 105.4 92.1999 105.9 93.0999Z",
    fill: "url(#paint119_linear_319_738)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.4 117C112.3 117.5 123.3 113.8 131.8 107C140.3 100.2 146.2 90.2 148.1 79.5",
    stroke: "url(#paint120_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.6 217.6C406.3 251.2 366.6 276.3 334.2 273.1C292.1 269 273.8 212.3 298 177.8C330.8 130.9 409.9 160.5 407.6 217.6Z",
    stroke: "url(#paint121_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.5 167.2C334.9 159.6 353.7 158.9 369.3 166.1C384.9 173.4 398.2 189.6 400.1 206.6C402.1 223.7 395.8 242.5 381 251.3",
    stroke: "url(#paint122_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.1 200.4C303.9 201.7 303.7 203 303.7 204.1C303.6 209 306.7 211.6 311.1 212.7C315.7 213.9 320.5 214.5 325.2 214.5C328.2 214.5 331.5 214.2 333.4 211.9C337.8 206.4 332.7 197.1 329.8 192C327.2 187.4 323 179.5 316.6 181.4C309.8 183.3 305.4 193 304.1 200.4Z",
    stroke: "url(#paint123_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.7 192.5C319.1 191.9 318.5 191.2 318.3 190.4C318 189.6 318.2 188.6 318.9 188.1C319.5 187.7 320.3 187.7 320.9 188C321.5 188.3 322.1 188.8 322.6 189.2C323.8 190.4 332.3 198.8 330.7 200.6C328.9 202.4 320.8 193.6 319.7 192.5Z",
    fill: "url(#paint124_linear_319_738)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.6 204C313.8 203.8 312.9 203.6 312.1 203.8C311.3 204 310.5 204.6 310.3 205.4C310.2 206.1 310.6 206.8 311.1 207.2C311.6 207.7 312.3 207.9 313 208.1C314.7 208.6 326.1 212.1 326.8 209.9C327.8 207.4 316.2 204.4 314.6 204Z",
    fill: "url(#paint125_linear_319_738)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.8 199C312 198.6 311.3 198.2 310.8 197.5C310.3 196.8 310.1 195.8 310.6 195.1C311 194.5 311.7 194.3 312.4 194.3C313.1 194.3 313.8 194.6 314.4 194.9C316 195.6 326.8 200.7 325.9 202.9C324.8 205.3 314.2 199.7 312.8 199Z",
    fill: "url(#paint126_linear_319_738)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.9 177.4C341.7 178 340.6 178.6 339.6 179.2C335.5 181.9 335.2 185.9 336.8 190.2C338.5 194.7 340.6 198.9 343.3 202.9C345 205.4 347.2 207.9 350.1 208.1C357.2 208.6 361.9 199.1 364.5 193.8C366.8 189.1 370.9 181.1 365.7 176.9C360.2 172.4 349.7 174.2 342.9 177.4Z",
    stroke: "url(#paint127_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.3 185.7C358.5 184.9 358.7 184 359.2 183.3C359.7 182.6 360.6 182.2 361.4 182.5C362.1 182.7 362.5 183.4 362.7 184.1C362.9 184.8 362.8 185.5 362.6 186.2C362.3 187.9 360.2 199.6 357.8 199.3C355.3 198.9 357.9 187.2 358.3 185.7Z",
    fill: "url(#paint128_linear_319_738)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.6 190.1C345.4 189.6 345.2 189.1 344.8 188.7C344.4 188.3 343.8 188.1 343.4 188.4C343 188.6 342.8 189 342.7 189.5C342.7 189.9 342.8 190.4 342.9 190.8C343.2 191.8 345.4 198.9 346.8 198.5C348.4 198 345.9 191.1 345.6 190.1Z",
    fill: "url(#paint129_linear_319_738)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349 183.7C348.9 182.9 348.8 182 349.1 181.2C349.4 180.4 350.1 179.7 350.9 179.7C351.6 179.7 352.2 180.2 352.6 180.8C353 181.4 353.1 182.1 353.2 182.8C353.5 184.5 355.4 196.3 353.2 196.7C350.6 197.1 349.2 185.3 349 183.7Z",
    fill: "url(#paint130_linear_319_738)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.7 216.8C386.5 215.5 386.3 214.2 386 213.1C384.7 208.4 381 206.9 376.4 207.1C371.7 207.3 366.9 208.1 362.4 209.5C359.5 210.3 356.4 211.7 355.4 214.4C352.8 221 360.5 228.4 364.7 232.4C368.5 236 374.9 242.3 380.5 238.7C386.2 234.8 387.7 224.3 386.7 216.8Z",
    stroke: "url(#paint131_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.6 216.4C376.5 216.4 377.3 216.3 378.1 215.9C378.9 215.5 379.5 214.7 379.3 213.8C379.2 213.1 378.6 212.5 378 212.3C377.4 212 376.6 212 375.9 212C374.2 212 362.2 212 362.2 214.3C362 217 374 216.5 375.6 216.4Z",
    fill: "url(#paint132_linear_319_738)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.8 220.7C379.6 220.9 380.5 221 381.2 221.5C381.9 222 382.4 222.9 382.1 223.7C381.9 224.4 381.3 224.8 380.6 225C379.9 225.2 379.2 225.1 378.5 225C376.8 224.8 365 223.1 365.2 220.8C365.5 218.2 377.2 220.4 378.8 220.7Z",
    fill: "url(#paint133_linear_319_738)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.9 220C338.7 219.2 340.7 218.2 342.6 218.8C343.9 219.2 344.8 220.3 345.7 221.4C350.9 227.8 356.2 234.2 361.4 240.6C361.9 241.2 362.3 241.8 362.4 242.5C362.5 243.6 361.6 244.5 360.8 245.2C356.3 248.9 350.5 250.8 344.7 251.5C337.5 252.4 330 251.5 323.6 248.2C319.7 246.2 316.3 243.4 313.7 239.9C311.8 237.3 310.1 234.2 309.5 230.9C308.9 227.3 310.5 225.2 314.2 224.9C318 224.6 321.9 224.5 325.7 223.8C329.6 223.3 333.3 221.7 336.9 220Z",
    stroke: "url(#paint134_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.9 191.3C447.6 207.8 405.4 187.2 391.2 157.9C372.6 119.9 411.2 74.6 453.3 77C510.3 80.3 526.7 163.2 476.9 191.3Z",
    stroke: "url(#paint135_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.7 132.3C439.4 133.4 441.2 134.6 441.7 136.5C442 137.8 441.6 139.2 441.1 140.5C438.4 148.3 435.7 156.1 433 163.9C432.8 164.6 432.5 165.3 431.9 165.7C431 166.4 429.8 166.1 428.7 165.7C423.2 163.8 418.6 159.9 414.9 155.3C410.4 149.7 407.2 142.8 406.6 135.6C406.2 131.3 406.9 126.9 408.5 122.8C409.7 119.8 411.4 116.7 413.9 114.5C416.6 112.1 419.3 112.4 421.4 115.3C423.6 118.4 425.8 121.7 428.4 124.5C431.1 127.8 434.4 130.2 437.7 132.3Z",
    stroke: "url(#paint136_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.2 154.5C428.9 155 428.7 155.4 428.2 155.7C427.8 156 427.2 156.1 426.7 155.8C426.3 155.5 426.2 155.1 426.2 154.6C426.2 154.2 426.4 153.8 426.6 153.4C427.1 152.4 430.4 145.9 431.7 146.5C433.4 147.2 429.7 153.6 429.2 154.5Z",
    fill: "url(#paint137_linear_319_738)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.1 149.2C421.4 149.7 420.7 150.3 419.9 150.5C419.1 150.7 418.1 150.5 417.6 149.8C417.2 149.2 417.3 148.4 417.6 147.8C417.9 147.2 418.4 146.7 419 146.2C420.3 145 429.3 137.2 430.9 138.9C432.7 140.8 423.3 148.2 422.1 149.2Z",
    fill: "url(#paint138_linear_319_738)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.1 140C415.3 140.3 414.5 140.7 413.6 140.6C412.7 140.6 411.9 140.1 411.6 139.3C411.4 138.6 411.7 137.9 412.1 137.3C412.6 136.8 413.2 136.4 413.8 136.1C415.4 135.3 426.1 130.1 427.2 132.2C428.5 134.6 417.6 139.3 416.1 140Z",
    fill: "url(#paint139_linear_319_738)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416 129.2C415.5 129.2 414.9 129.2 414.5 129C414 128.8 413.6 128.3 413.7 127.8C413.7 127.4 414.1 127 414.5 126.8C414.9 126.6 415.3 126.6 415.8 126.5C416.9 126.4 424.2 126 424.4 127.5C424.4 129.1 417 129.2 416 129.2Z",
    fill: "url(#paint140_linear_319_738)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.6 114.5C391.3 124 389.6 135.5 391.9 146.1C394.2 156.7 400.5 166.5 409.2 173",
    stroke: "url(#paint141_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.7 209.8C48.8 229 15.7 224.4 3.3 220.3C-14.7 214.3 -30.9 202.5 -41.5 186.7C-42.9 184.6 -44.2 181.7 -42.7 179.7C-41.5 178.2 -39.3 178.1 -37.5 178.8C-35.7 179.5 -34.5 181 -33.2 182.4C-22.2 193.7 -6.8 200.3 8.9 201.3C16.8 201.8 24.9 200.8 32.5 198.4C39.6 196.1 47.9 196.9 51 205C57.5 204.3 64.6 205.8 70.2 209.2C69.8 210.8 69.6 212.4 69.2 214C63.8 211.3 58.6 208.3 52.7 209.8Z",
    stroke: "url(#paint142_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2 197.4C40.3 198 38.3 201.2 39.3 202.9C39.8 203.7 40.8 204.4 40.8 205.4C40.8 206.7 39.1 207.2 38 208C36.7 208.8 35.9 210.5 36.1 212C36.3 213.6 37.4 215 38.9 215.5C40.1 215.9 41.8 215.9 42.3 217.2C42.6 217.8 42.4 218.5 42.5 219.1C42.5 219.7 43 221.3 44.5 220.5",
    stroke: "url(#paint143_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4 219.7C4.89995 218.1 -15.9 208.3 -30.8 192.7",
    stroke: "url(#paint144_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6 218.7C33.8 218.8 32.9 219 32.1 219.1",
    stroke: "url(#paint145_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125 248.2C113 246.3 115 225.7 117.2 218C120.4 206.7 127.3 196.4 136.7 189.4C138 188.5 139.7 187.6 141 188.5C141.9 189.2 142.1 190.6 141.7 191.7C141.3 192.8 140.4 193.6 139.6 194.5C132.9 201.6 129.3 211.3 129.1 221C129 225.9 129.8 230.9 131.5 235.5C133.1 239.8 132.9 244.9 127.9 247.1C128.5 251.1 127.8 255.5 125.8 259.1C124.8 258.9 123.8 258.8 122.8 258.6C124.4 255.1 126.1 251.8 125 248.2Z",
    stroke: "url(#paint146_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.2 232.2C118.6 218.9 124.1 205.8 133.3 196.1",
    stroke: "url(#paint147_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1 91.3C16.1 96.5 6.20005 78.4 3.60005 70.7C-0.0999503 59.6 -0.199952 47.2 3.70005 36.1C4.20005 34.6 5.20005 32.9 6.70005 32.9C7.90005 32.9 8.80005 34 9.00005 35.1C9.30005 36.2 9.00005 37.4 8.80005 38.6C7.30005 48.2 9.70005 58.3 15.0001 66.4C17.7001 70.5 21.1 74.1 25.2 77C29 79.7 31.6001 84 28.8001 88.6C31.6001 91.6 33.4001 95.6 33.8001 99.7C32.8001 100.1 32.0001 100.6 31.0001 101C30.4001 97.3 30.0001 93.6 27.1 91.3Z",
    stroke: "url(#paint148_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3001 81.5C28.3001 80.8 26.0001 81 25.5001 82.1C25.3001 82.7 25.3001 83.4 24.8001 83.8C24.1001 84.3 23.3001 83.6 22.5001 83.4C21.6001 83.1 20.5001 83.3 19.8001 83.9C19.1001 84.6 18.8001 85.6 19.1001 86.6C19.3001 87.4 20.0001 88.2 19.6001 88.9C19.4001 89.2 19.0001 89.4 18.7001 89.7C18.4001 90 17.8001 90.7 18.8001 91.2",
    stroke: "url(#paint149_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4001 81.9C5.20008 70.7 2.40007 56.7 4.60007 43.6",
    stroke: "url(#paint150_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 85.6C15.6 85.2 15.2 84.9 14.9 84.5",
    stroke: "url(#paint151_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.9 109.3C236.3 109.8 235.1 143.2 237 156.1C239.8 174.9 248.6 192.8 262.3 206.1C264.1 207.9 266.8 209.7 269 208.5C270.7 207.6 271.2 205.4 270.7 203.6C270.2 201.8 269.1 200.2 268 198.7C258.8 185.9 255 169.6 256.8 154C257.7 146.1 260 138.3 263.8 131.3C267.3 124.7 268 116.4 260.6 111.9C262.4 105.6 262.2 98.4 259.8 92.2C258.1 92.4 256.6 92.2 254.9 92.3C256.3 98.1 258.4 103.7 255.9 109.3Z",
    stroke: "url(#paint152_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.2 121.8C265.2 123.6 261.8 125 260.3 123.7C259.6 123.1 259.1 122 258.1 121.8C256.8 121.6 256 123.1 255.1 124.1C254 125.2 252.3 125.7 250.8 125.3C249.3 124.8 248.1 123.5 247.9 122C247.7 120.7 248 119.1 246.9 118.3C246.4 117.9 245.7 118 245 117.8C244.4 117.6 243 116.9 244 115.5",
    stroke: "url(#paint153_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.5 133.5C239.3 155 245.4 177.1 258.1 194.6",
    stroke: "url(#paint154_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244 125.5C243.7 126.3 243.4 127.1 243.1 127.9",
    stroke: "url(#paint155_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.1 205.6C420.2 205.2 421.4 205.3 422.5 205.7C424.7 206.5 426.4 208.9 426.2 211.2C426 213.6 424 215.7 421.6 215.8C416.9 215.8 414.4 207.4 419.1 205.6Z",
    stroke: "url(#paint156_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.2 156.6C221.3 156.2 222.5 156.3 223.6 156.7C225.8 157.5 227.5 159.9 227.3 162.2C227.1 164.6 225.1 166.7 222.7 166.8C218 166.9 215.5 158.5 220.2 156.6Z",
    stroke: "url(#paint157_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380 113.2C380.6 113.6 380.9 114.3 381.1 115C381.4 116.4 380.7 118.1 379.4 118.7C378.1 119.4 376.3 119 375.5 117.8C373.9 115.4 377.5 111.4 380 113.2Z",
    stroke: "url(#paint158_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.5 134.9C127.1 135.3 127.4 136 127.6 136.7C127.9 138.1 127.2 139.8 125.9 140.4C124.6 141.1 122.8 140.7 122 139.5C120.4 137 124 133 126.5 134.9Z",
    stroke: "url(#paint159_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.1 98.9C241.7 99.3 242 100 242.2 100.7C242.5 102.1 241.8 103.8 240.5 104.4C239.2 105.1 237.4 104.7 236.6 103.5C235 101.1 238.6 97 241.1 98.9Z",
    stroke: "url(#paint160_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.6 221.1C102.2 221.5 102.5 222.2 102.7 222.9C103 224.3 102.3 226 101 226.6C99.7 227.3 97.9 226.9 97.1 225.7C95.4 223.3 99.1 219.3 101.6 221.1Z",
    stroke: "url(#paint161_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.9 181.1C279.5 181.5 279.8 182.2 280 182.9C280.3 184.3 279.6 186 278.3 186.6C277 187.3 275.2 186.9 274.4 185.7C272.8 183.2 276.5 179.2 278.9 181.1Z",
    stroke: "url(#paint162_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.3001 135.5C90.9001 135.9 91.2001 136.6 91.4001 137.3C91.7001 138.7 91.0001 140.4 89.7001 141C88.4001 141.7 86.6001 141.3 85.8001 140.1C84.2001 137.7 87.9001 133.7 90.3001 135.5Z",
    stroke: "url(#paint163_linear_319_738)",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_319_738",
    x1: 226.307,
    y1: 94.7321,
    x2: 132.384,
    y2: 94.7321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_319_738",
    x1: 146.6,
    y1: 132.899,
    x2: 142.341,
    y2: 132.899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_319_738",
    x1: 148.958,
    y1: 151.603,
    x2: 142.9,
    y2: 151.603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_319_738",
    x1: 175.257,
    y1: 125.78,
    x2: 167.9,
    y2: 125.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_319_738",
    x1: 172.4,
    y1: 105.14,
    x2: 168.846,
    y2: 105.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_319_738",
    x1: 183.974,
    y1: 146.486,
    x2: 176.6,
    y2: 146.486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_319_738",
    x1: 170.2,
    y1: 163.448,
    x2: 166.046,
    y2: 163.448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_319_738",
    x1: 152.1,
    y1: 173.746,
    x2: 146.8,
    y2: 173.746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_319_738",
    x1: 192.764,
    y1: 164.564,
    x2: 185.4,
    y2: 164.564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_319_738",
    x1: 205.3,
    y1: 138.845,
    x2: 201.99,
    y2: 138.845,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_319_738",
    x1: 197.4,
    y1: 115.911,
    x2: 192.3,
    y2: 115.911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_319_738",
    x1: 185.4,
    y1: 102.674,
    x2: 181.965,
    y2: 102.674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_319_738",
    x1: 212.3,
    y1: 96.1104,
    x2: 209,
    y2: 96.1104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_319_738",
    x1: 216.106,
    y1: 110.85,
    x2: 213.3,
    y2: 110.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_319_738",
    x1: 196.006,
    y1: 90.7513,
    x2: 193.358,
    y2: 90.7513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_319_738",
    x1: 220.708,
    y1: 78.6461,
    x2: 217.2,
    y2: 78.6461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_319_738",
    x1: 196.2,
    y1: 75.2396,
    x2: 192.493,
    y2: 75.2396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_319_738",
    x1: 204.9,
    y1: 57.0333,
    x2: 201.31,
    y2: 57.0333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_319_738",
    x1: 213.025,
    y1: 46.541,
    x2: 210.4,
    y2: 46.541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_319_738",
    x1: 197.4,
    y1: 40.3825,
    x2: 193.804,
    y2: 40.3825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_319_738",
    x1: 200.655,
    y1: 21.6059,
    x2: 198.3,
    y2: 21.6059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_319_738",
    x1: 187.3,
    y1: 32.8,
    x2: 184.9,
    y2: 32.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_319_738",
    x1: 222.473,
    y1: 37.1446,
    x2: 219.4,
    y2: 37.1446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_319_738",
    x1: 185,
    y1: 73.55,
    x2: 182.661,
    y2: 73.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_319_738",
    x1: 228.658,
    y1: 90.898,
    x2: 226,
    y2: 90.898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_319_738",
    x1: 222.26,
    y1: 124.014,
    x2: 218.3,
    y2: 124.014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_319_738",
    x1: 211.627,
    y1: 144.581,
    x2: 206.4,
    y2: 144.581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_319_738",
    x1: 376.299,
    y1: 136.826,
    x2: 273.492,
    y2: 136.826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_319_738",
    x1: 356.6,
    y1: 145.869,
    x2: 353.4,
    y2: 145.869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_319_738",
    x1: 365.583,
    y1: 137.811,
    x2: 361.949,
    y2: 137.811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_319_738",
    x1: 344.509,
    y1: 134.378,
    x2: 338.927,
    y2: 134.378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_319_738",
    x1: 332.839,
    y1: 143.155,
    x2: 330,
    y2: 143.155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_319_738",
    x1: 350,
    y1: 122.501,
    x2: 346.746,
    y2: 122.501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_319_738",
    x1: 362.9,
    y1: 122.59,
    x2: 360.48,
    y2: 122.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_319_738",
    x1: 374.8,
    y1: 127.709,
    x2: 372.46,
    y2: 127.709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_319_738",
    x1: 356.483,
    y1: 111.469,
    x2: 351.2,
    y2: 111.469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_319_738",
    x1: 337.2,
    y1: 113.9,
    x2: 335.4,
    y2: 113.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_319_738",
    x1: 328.9,
    y1: 126.556,
    x2: 326.982,
    y2: 126.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_319_738",
    x1: 326.679,
    y1: 137.555,
    x2: 324.1,
    y2: 137.555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_319_738",
    x1: 312.8,
    y1: 126.2,
    x2: 311.581,
    y2: 126.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_319_738",
    x1: 320.1,
    y1: 119.211,
    x2: 316.921,
    y2: 119.211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_319_738",
    x1: 316.5,
    y1: 136.295,
    x2: 314.925,
    y2: 136.295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_319_738",
    x1: 301.5,
    y1: 128.6,
    x2: 299.531,
    y2: 128.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_319_738",
    x1: 309.308,
    y1: 142.317,
    x2: 306.858,
    y2: 142.317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_319_738",
    x1: 296.91,
    y1: 144.474,
    x2: 295.1,
    y2: 144.474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_319_738",
    x1: 288.3,
    y1: 144.294,
    x2: 286.562,
    y2: 144.294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_319_738",
    x1: 291.308,
    y1: 154.353,
    x2: 289.6,
    y2: 154.353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_319_738",
    x1: 280,
    y1: 159.353,
    x2: 278.887,
    y2: 159.353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_319_738",
    x1: 291.108,
    y1: 161.538,
    x2: 288.3,
    y2: 161.538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_319_738",
    x1: 280.2,
    y1: 143.292,
    x2: 278.253,
    y2: 143.292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_319_738",
    x1: 312.115,
    y1: 147.856,
    x2: 309.3,
    y2: 147.856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_319_738",
    x1: 305.6,
    y1: 120.374,
    x2: 302.135,
    y2: 120.374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_319_738",
    x1: 324.8,
    y1: 111.04,
    x2: 320.9,
    y2: 111.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_319_738",
    x1: 339.6,
    y1: 108.7,
    x2: 334.6,
    y2: 108.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_319_738",
    x1: 142.558,
    y1: 262.752,
    x2: 64.9318,
    y2: 262.752,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_319_738",
    x1: 126.181,
    y1: 166.062,
    x2: 84.3574,
    y2: 166.062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_319_738",
    x1: 104.9,
    y1: 178.6,
    x2: 102.492,
    y2: 178.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_319_738",
    x1: 114.5,
    y1: 187.1,
    x2: 102.9,
    y2: 187.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_319_738",
    x1: 102.3,
    y1: 185.45,
    x2: 90.5,
    y2: 185.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_319_738",
    x1: 107.2,
    y1: 180.5,
    x2: 103.4,
    y2: 180.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_319_738",
    x1: 114.1,
    y1: 167.25,
    x2: 103.9,
    y2: 167.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_319_738",
    x1: 103.6,
    y1: 162.5,
    x2: 91.6,
    y2: 162.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_319_738",
    x1: 112,
    y1: 154.4,
    x2: 104.6,
    y2: 154.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_319_738",
    x1: 104.6,
    y1: 150.8,
    x2: 99.3727,
    y2: 150.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_319_738",
    x1: 285.479,
    y1: 244.961,
    x2: 238.85,
    y2: 244.961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_319_738",
    x1: 269.9,
    y1: 233.65,
    x2: 243.6,
    y2: 233.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_319_738",
    x1: 309.879,
    y1: 83.6614,
    x2: 263.25,
    y2: 83.6614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_319_738",
    x1: 294.3,
    y1: 72.3501,
    x2: 268,
    y2: 72.3501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_319_738",
    x1: 274.9,
    y1: 68.2001,
    x2: 269.7,
    y2: 68.2001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_319_738",
    x1: 290.2,
    y1: 62.0138,
    x2: 276.5,
    y2: 62.0138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_319_738",
    x1: 279.7,
    y1: 71.6501,
    x2: 278,
    y2: 71.6501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_319_738",
    x1: 284.5,
    y1: 84.7001,
    x2: 281.476,
    y2: 84.7001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_319_738",
    x1: 303.2,
    y1: 81.9283,
    x2: 287.4,
    y2: 81.9283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_319_738",
    x1: 291,
    y1: 95.05,
    x2: 290.012,
    y2: 95.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_319_738",
    x1: 303,
    y1: 94.3747,
    x2: 293.4,
    y2: 94.3747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_319_738",
    x1: 387.009,
    y1: 82.3962,
    x2: 329.649,
    y2: 82.3962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_319_738",
    x1: 393.1,
    y1: 87.85,
    x2: 347.2,
    y2: 87.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_319_738",
    x1: 381.323,
    y1: 86.35,
    x2: 378.3,
    y2: 86.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_319_738",
    x1: 379.2,
    y1: 97.1,
    x2: 368.4,
    y2: 97.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_319_738",
    x1: 373,
    y1: 87.1,
    x2: 372.1,
    y2: 87.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_319_738",
    x1: 364.5,
    y1: 78.7501,
    x2: 358.7,
    y2: 78.7501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_319_738",
    x1: 360,
    y1: 87.55,
    x2: 345.9,
    y2: 87.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_319_738",
    x1: 353.1,
    y1: 74.6501,
    x2: 345.6,
    y2: 74.6501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_319_738",
    x1: 349,
    y1: 79.6465,
    x2: 338.3,
    y2: 79.6465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_319_738",
    x1: 78.0144,
    y1: 151.19,
    x2: 1.87891,
    y2: 151.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_319_738",
    x1: 54.6,
    y1: 137.4,
    x2: 2.09997,
    y2: 137.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_319_738",
    x1: 15.6,
    y1: 134.15,
    x2: 12.0491,
    y2: 134.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_319_738",
    x1: 38.1,
    y1: 122.173,
    x2: 18.4,
    y2: 122.173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_319_738",
    x1: 25.1,
    y1: 137.1,
    x2: 23.9,
    y2: 137.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_319_738",
    x1: 35.5,
    y1: 154.75,
    x2: 33.1482,
    y2: 154.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_319_738",
    x1: 64.1001,
    y1: 146.59,
    x2: 40.3,
    y2: 146.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_319_738",
    x1: 52.2001,
    y1: 167.3,
    x2: 47.6398,
    y2: 167.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_319_738",
    x1: 68.2,
    y1: 163.735,
    x2: 52.6,
    y2: 163.735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_319_738",
    x1: 229.674,
    y1: 213.035,
    x2: 152.545,
    y2: 213.035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_319_738",
    x1: 229.8,
    y1: 200.75,
    x2: 177.7,
    y2: 200.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_319_738",
    x1: 216.8,
    y1: 186.172,
    x2: 195.9,
    y2: 186.172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_319_738",
    x1: 222.349,
    y1: 200.1,
    x2: 215.4,
    y2: 200.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_319_738",
    x1: 207.2,
    y1: 197.041,
    x2: 200.6,
    y2: 197.041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_319_738",
    x1: 197.5,
    y1: 207.835,
    x2: 175.8,
    y2: 207.835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_319_738",
    x1: 197.675,
    y1: 225.1,
    x2: 193.2,
    y2: 225.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_319_738",
    x1: 184.4,
    y1: 223.748,
    x2: 165.2,
    y2: 223.748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_319_738",
    x1: 156.368,
    y1: 61.1615,
    x2: 37.9882,
    y2: 61.1615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_319_738",
    x1: 148.901,
    y1: 33.2966,
    x2: 44.9,
    y2: 33.2966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_319_738",
    x1: 90.5773,
    y1: 78.6309,
    x2: 55.002,
    y2: 78.6309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_319_738",
    x1: 78.9392,
    y1: 69.5058,
    x2: 62.1871,
    y2: 69.5058,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_319_738",
    x1: 85.268,
    y1: 81.4413,
    x2: 71.9362,
    y2: 81.4413,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_319_738",
    x1: 78.5683,
    y1: 77.3846,
    x2: 63.5555,
    y2: 77.3846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_319_738",
    x1: 97.0469,
    y1: 41.2797,
    x2: 65.5,
    y2: 41.2797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_319_738",
    x1: 92.5697,
    y1: 37.5678,
    x2: 79.2405,
    y2: 37.5678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_319_738",
    x1: 85.8161,
    y1: 50.9927,
    x2: 75.4,
    y2: 50.9927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_319_738",
    x1: 87.4518,
    y1: 42.4973,
    x2: 71.6146,
    y2: 42.4973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_319_738",
    x1: 137.603,
    y1: 41.8381,
    x2: 102.575,
    y2: 41.8381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_319_738",
    x1: 127.783,
    y1: 49.419,
    x2: 118.315,
    y2: 49.419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_319_738",
    x1: 117.015,
    y1: 40.4016,
    x2: 106.91,
    y2: 40.4016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear_319_738",
    x1: 126.325,
    y1: 42.0278,
    x2: 114.15,
    y2: 42.0278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_319_738",
    x1: 133.181,
    y1: 82.4119,
    x2: 90.5629,
    y2: 82.4119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint116_linear_319_738",
    x1: 124.8,
    y1: 71.2055,
    x2: 114.2,
    y2: 71.2055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear_319_738",
    x1: 123.685,
    y1: 79.0523,
    x2: 107.759,
    y2: 79.0523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear_319_738",
    x1: 117.34,
    y1: 87.1495,
    x2: 103.36,
    y2: 87.1495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint119_linear_319_738",
    x1: 106.4,
    y1: 91.2399,
    x2: 100.462,
    y2: 91.2399,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint120_linear_319_738",
    x1: 148.1,
    y1: 98.2724,
    x2: 101.4,
    y2: 98.2724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint121_linear_319_738",
    x1: 407.649,
    y1: 213.969,
    x2: 287.187,
    y2: 213.969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint122_linear_319_738",
    x1: 400.461,
    y1: 206.19,
    x2: 319.5,
    y2: 206.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint123_linear_319_738",
    x1: 335.119,
    y1: 197.805,
    x2: 303.698,
    y2: 197.805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint124_linear_319_738",
    x1: 330.9,
    y1: 194.314,
    x2: 318.165,
    y2: 194.314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint125_linear_319_738",
    x1: 326.861,
    y1: 207.168,
    x2: 310.285,
    y2: 207.168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint126_linear_319_738",
    x1: 325.953,
    y1: 198.897,
    x2: 310.31,
    y2: 198.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint127_linear_319_738",
    x1: 368.219,
    y1: 191.16,
    x2: 335.899,
    y2: 191.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint128_linear_319_738",
    x1: 362.809,
    y1: 190.853,
    x2: 356.727,
    y2: 190.853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint129_linear_319_738",
    x1: 347.331,
    y1: 193.386,
    x2: 342.7,
    y2: 193.386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint130_linear_319_738",
    x1: 354.248,
    y1: 188.205,
    x2: 348.9,
    y2: 188.205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint131_linear_319_738",
    x1: 386.988,
    y1: 223.429,
    x2: 354.876,
    y2: 223.429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint132_linear_319_738",
    x1: 379.339,
    y1: 214.251,
    x2: 362.198,
    y2: 214.251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint133_linear_319_738",
    x1: 382.189,
    y1: 222.33,
    x2: 365.198,
    y2: 222.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint134_linear_319_738",
    x1: 362.408,
    y1: 235.223,
    x2: 309.377,
    y2: 235.223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint135_linear_319_738",
    x1: 506.534,
    y1: 137.037,
    x2: 386.402,
    y2: 137.037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint136_linear_319_738",
    x1: 441.803,
    y1: 139.506,
    x2: 406.49,
    y2: 139.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint137_linear_319_738",
    x1: 432.143,
    y1: 151.221,
    x2: 426.2,
    y2: 151.221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint138_linear_319_738",
    x1: 431.128,
    y1: 144.616,
    x2: 417.336,
    y2: 144.616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint139_linear_319_738",
    x1: 427.307,
    y1: 136.16,
    x2: 411.536,
    y2: 136.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint140_linear_319_738",
    x1: 424.4,
    y1: 127.788,
    x2: 413.685,
    y2: 127.788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint141_linear_319_738",
    x1: 409.2,
    y1: 143.75,
    x2: 390.898,
    y2: 143.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint142_linear_319_738",
    x1: 70.2,
    y1: 201.158,
    x2: -43.3684,
    y2: 201.158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint143_linear_319_738",
    x1: 44.5,
    y1: 209.06,
    x2: 36.0695,
    y2: 209.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint144_linear_319_738",
    x1: 26.4,
    y1: 206.2,
    x2: -30.8,
    y2: 206.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint145_linear_319_738",
    x1: 34.6,
    y1: 218.9,
    x2: 32.1,
    y2: 218.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint146_linear_319_738",
    x1: 141.896,
    y1: 223.614,
    x2: 115.535,
    y2: 223.614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint147_linear_319_738",
    x1: 133.3,
    y1: 214.15,
    x2: 118.2,
    y2: 214.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint148_linear_319_738",
    x1: 33.8001,
    y1: 66.95,
    x2: 0.800048,
    y2: 66.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint149_linear_319_738",
    x1: 29.3001,
    y1: 86.1458,
    x2: 18.246,
    y2: 86.1458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint150_linear_319_738",
    x1: 12.4001,
    y1: 62.75,
    x2: 3.86755,
    y2: 62.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint151_linear_319_738",
    x1: 16,
    y1: 85.05,
    x2: 14.9,
    y2: 85.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint152_linear_319_738",
    x1: 270.885,
    y1: 150.544,
    x2: 236.354,
    y2: 150.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint153_linear_319_738",
    x1: 266.2,
    y1: 120.468,
    x2: 243.65,
    y2: 120.468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint154_linear_319_738",
    x1: 258.1,
    y1: 164.05,
    x2: 241.059,
    y2: 164.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint155_linear_319_738",
    x1: 244,
    y1: 126.7,
    x2: 243.1,
    y2: 126.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint156_linear_319_738",
    x1: 426.216,
    y1: 210.573,
    x2: 416.586,
    y2: 210.573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint157_linear_319_738",
    x1: 227.316,
    y1: 161.573,
    x2: 217.686,
    y2: 161.573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint158_linear_319_738",
    x1: 381.169,
    y1: 115.896,
    x2: 375.104,
    y2: 115.896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint159_linear_319_738",
    x1: 127.669,
    y1: 137.574,
    x2: 121.604,
    y2: 137.574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint160_linear_319_738",
    x1: 242.269,
    y1: 101.578,
    x2: 236.204,
    y2: 101.578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint161_linear_319_738",
    x1: 102.769,
    y1: 223.796,
    x2: 96.6682,
    y2: 223.796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint162_linear_319_738",
    x1: 280.069,
    y1: 183.774,
    x2: 274.011,
    y2: 183.774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint163_linear_319_738",
    x1: 91.469,
    y1: 138.196,
    x2: 85.4111,
    y2: 138.196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_319_738"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 639.5,
    height: 352.2,
    fill: "white",
    transform: "translate(-80)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgShape);
export default __webpack_public_path__ + "static/media/bg-shape.7a4698c07d196f2654426df8045ddfbe.svg";
export { ForwardRef as ReactComponent };